export default {
  NAME: {
    field: 'name',
    multiple: false,
    required: true,
  },
  CATEGORY: {
    field: 'categories',
    multiple: false,
    required: true,
  },
  'SUB CATEGORY': {
    field: 'subCategories',
    multiple: false,
  },
  LOCATION: {
    field: 'location',
    multiple: false,
  },
  STREET: {
    field: 'street',
    multiple: false,
  },
  CITY: {
    field: 'city',
    multiple: false,
  },
  STATE: {
    field: 'state',
    multiple: false,
  },
  ZIP: {
    field: 'zip',
    multiple: false,
  },
  PHONE: {
    field: 'phone',
    multiple: false,
  },
  'CONTACT NAME': {
    field: 'contactName',
    multiple: false,
  },
  'CONTACT EMAIL': {
    field: 'contactEmail',
    multiple: false,
  },
};
